export class ComponentData {
  constructor(public classType: any, public componentInstance: any) {}
}
